import {
  CSS3,
  Express,
  HTML5,
  Javascript,
  Mongodb,
  Nodejs,
  Reactjs,
  dalle,
  // netflix,
  // Recipe,
  // Translate,
  // BITS,
  // POS,
  // Ecommerce,
  Travelinds,
  Boby,
  IIATCR,
  SMARTWAVE,
  VILLAMIRAA,
  COCHINSTEEL,
} from "./assets";

export const projectStats = [
  {
    name: "Total Projects",
    value: "15+",
  },
  {
    name: "Website Design",
    value: "8+",
  },
  {
    name: "Web Development",
    value: "7+",
  },
  {
    name: "Clients worldwide",
    value: "+15",
  },
];

export const tools = [
  {
    name: "MongoDB",
    icon: Mongodb,
  },
  {
    name: "Express",
    icon: Express,
  },
  {
    name: "React",
    icon: Reactjs,
  },
  {
    name: "NodeJs",
    icon: Nodejs,
  },

];

export const skills = [
  {
    name: "ReactJs",
    value: 98,
    icon: Reactjs,
  },
  {
    name: "NodeJs",
    value: 96,
    icon: Nodejs,
  },
 
  {
    name: "MongoDB",
    value: 98,
    icon: Mongodb,
  },
  {
    name: "CSS3",
    value: 98,
    icon: CSS3,
  },
  {
    name: "HTML5",
    value: 98,
    icon: HTML5,
  },
  {
    name: "JavaScript",
    value: 88,
    icon: Javascript,
  },

];

export const projects = [
  {
    id: 1,
    title: "Dall-E 2.0",
    cat: "Fullstack Website",
    url: "https://github.com/ablecj/dalle.git",
    img: dalle,
  },
  {
    id: 2,
    title: "Netflix",
    cat: "Web Design",
    url: "https://www.villamiraa.com/",
    img: VILLAMIRAA,
  },
  {
    id: 3,
    title: "Cochin Steel",
    cat: "Web Development",
    url: "https://www.cochinsteeluae.com/",
    img: COCHINSTEEL,
  },
  {
    id: 4,
    title: "Travel website",
    cat: "Web Design",
    url: "https://travelinds.com/",
    img: Travelinds,
  },
  {
    id: 5,
    title: "Portfolio",
    cat: "Web Design",
    url: "https://drbobyvarkey.com/",
    img: Boby,
  },
  {
    id: 6,
    title: "IIATCR",
    cat: "Web Development",
    url: "https://iiatcr.com/kalaasham/",
    img: IIATCR,
  },
  {
    id: 7,
    title: "Smart Wave",
    cat: "Web Development",
    url: "https://smartwaveav.com/",
    img: SMARTWAVE,
  },
];

export const softskills = [
  "Time management",
  "Communication",
  "Empathy",
  "Teamwork",
  "Helpfulness",
  "Creativity",
  "Self-learning",
  "Accountability",
  "Problem solving",
  "Open-mindedness",
];
